import { render, staticRenderFns } from "./FormParentSelection.vue?vue&type=template&id=7f1b06c7&scoped=true&"
import script from "./FormParentSelection.vue?vue&type=script&lang=js&"
export * from "./FormParentSelection.vue?vue&type=script&lang=js&"
import style0 from "./FormParentSelection.vue?vue&type=style&index=0&id=7f1b06c7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f1b06c7",
  null
  
)

export default component.exports